import script from "./linkArea.vue?vue&type=script&setup=true&lang=js"
export * from "./linkArea.vue?vue&type=script&setup=true&lang=js"

import "./linkArea.vue?vue&type=style&index=0&id=45363893&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45363893"]])

export default __exports__